// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"f095f6cd","359":"fe072144","511":"6d51739c"}[chunkId] + ".chunk.js";
};